import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/banner.png'
import _imports_1 from '@/assets/i1.png'
import _imports_2 from '@/assets/i6.png'
import _imports_3 from '@/assets/i9.png'
import _imports_4 from '@/assets/i7.png'
import _imports_5 from '@/assets/i8.png'
import _imports_6 from '@/assets/i4.png'
import _imports_7 from '@/assets/i130.png'
import _imports_8 from '@/assets/i127.png'
import _imports_9 from '@/assets/i128.png'
import _imports_10 from '@/assets/i129.png'
import _imports_11 from '@/assets/i133.png'
import _imports_12 from '@/assets/i34.png'
import _imports_13 from '@/assets/quesheng.png'


const _withScopeId = n => (_pushScopeId("data-v-97d84264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "homeMain" }
const _hoisted_3 = { class: "bannerBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "t" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "serviceBox" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "dataBlock" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "titleBox" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "01.", -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "infoBox" }
const _hoisted_20 = { class: "topMinText" }
const _hoisted_21 = { class: "rigth" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "tt" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_25 = { class: "t" }
const _hoisted_26 = { class: "ss" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_28 = { class: "t" }
const _hoisted_29 = { class: "ss" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_31 = { class: "t" }
const _hoisted_32 = { class: "ss" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_34 = { class: "t" }
const _hoisted_35 = { class: "ss" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_37 = { class: "t" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = { class: "tt" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_41 = { class: "t" }
const _hoisted_42 = { class: "ss" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_44 = { class: "t" }
const _hoisted_45 = { class: "ss" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_47 = { class: "t" }
const _hoisted_48 = { class: "ss" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_50 = { class: "t" }
const _hoisted_51 = { class: "ss" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_53 = { class: "t" }
const _hoisted_54 = { class: "item" }
const _hoisted_55 = { class: "tt" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_5,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_57 = { class: "t" }
const _hoisted_58 = { class: "ss" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_60 = { class: "t" }
const _hoisted_61 = { class: "ss" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_63 = { class: "t" }
const _hoisted_64 = { class: "ss" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_66 = { class: "t" }
const _hoisted_67 = { class: "ss" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_69 = { class: "t" }
const _hoisted_70 = { class: "dataLine" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img2",
  src: _imports_6,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_72 = { class: "t1" }
const _hoisted_73 = { class: "t2" }
const _hoisted_74 = { class: "dataBlock3" }
const _hoisted_75 = { class: "blockOne" }
const _hoisted_76 = { class: "left" }
const _hoisted_77 = { class: "titleT" }
const _hoisted_78 = { class: "t" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_7,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_80 = { class: "right" }
const _hoisted_81 = { class: "itemT" }
const _hoisted_82 = { class: "iconT" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_8,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_84 = { class: "t" }
const _hoisted_85 = { class: "text" }
const _hoisted_86 = { class: "itemT" }
const _hoisted_87 = { class: "iconT" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_9,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_89 = { class: "t" }
const _hoisted_90 = { class: "text" }
const _hoisted_91 = { class: "itemT" }
const _hoisted_92 = { class: "iconT" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_10,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_94 = { class: "t" }
const _hoisted_95 = { class: "text" }
const _hoisted_96 = { class: "blockTwo" }
const _hoisted_97 = { class: "titleT" }
const _hoisted_98 = { class: "text" }
const _hoisted_99 = { class: "btnT" }
const _hoisted_100 = { class: "dataBlock4" }
const _hoisted_101 = { class: "content" }
const _hoisted_102 = { class: "titleBox" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "02.", -1))
const _hoisted_104 = { class: "t" }
const _hoisted_105 = { class: "tt" }
const _hoisted_106 = { class: "btnT" }
const _hoisted_107 = { class: "ts" }
const _hoisted_108 = { class: "swiperBox" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "itemBox" }
const _hoisted_111 = ["src"]
const _hoisted_112 = { class: "titleT" }
const _hoisted_113 = { class: "tt" }
const _hoisted_114 = { class: "itBox" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_11,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_116 = { class: "t" }
const _hoisted_117 = { class: "btn" }
const _hoisted_118 = { class: "t" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_7,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_120 = { class: "itemBoxTb" }
const _hoisted_121 = { class: "t" }
const _hoisted_122 = { class: "itemBoxNum" }
const _hoisted_123 = { class: "itemT" }
const _hoisted_124 = { class: "item" }
const _hoisted_125 = { class: "num" }
const _hoisted_126 = { class: "lable" }
const _hoisted_127 = ["innerHTML"]
const _hoisted_128 = { class: "itemT" }
const _hoisted_129 = { class: "item" }
const _hoisted_130 = { class: "num" }
const _hoisted_131 = { class: "lable" }
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = { class: "itemT" }
const _hoisted_134 = { class: "item" }
const _hoisted_135 = { class: "num" }
const _hoisted_136 = { class: "lable" }
const _hoisted_137 = ["innerHTML"]
const _hoisted_138 = { class: "itemT" }
const _hoisted_139 = { class: "item" }
const _hoisted_140 = { class: "num" }
const _hoisted_141 = ["innerHTML"]
const _hoisted_142 = { class: "dataBlock5" }
const _hoisted_143 = { class: "content" }
const _hoisted_144 = { class: "conentTT" }
const _hoisted_145 = { class: "titleT" }
const _hoisted_146 = { class: "info" }
const _hoisted_147 = { class: "dataBlock6" }
const _hoisted_148 = { class: "content" }
const _hoisted_149 = { class: "itemBox" }
const _hoisted_150 = { class: "left" }
const _hoisted_151 = { class: "t" }
const _hoisted_152 = { class: "m" }
const _hoisted_153 = { class: "btnT" }
const _hoisted_154 = { class: "newsBox" }
const _hoisted_155 = { class: "title" }
const _hoisted_156 = { class: "text" }
const _hoisted_157 = { class: "content" }
const _hoisted_158 = { class: "navBox" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = {
  key: 0,
  class: "newBox"
}
const _hoisted_161 = { class: "imgBox" }
const _hoisted_162 = ["src"]
const _hoisted_163 = { class: "titleT" }
const _hoisted_164 = { class: "msg" }
const _hoisted_165 = { class: "time" }
const _hoisted_166 = {
  key: 1,
  class: "line"
}
const _hoisted_167 = { class: "right" }
const _hoisted_168 = ["onClick"]
const _hoisted_169 = { class: "info" }
const _hoisted_170 = { class: "t" }
const _hoisted_171 = { class: "m" }
const _hoisted_172 = { class: "moreTime" }
const _hoisted_173 = { class: "time" }
const _hoisted_174 = { class: "more" }
const _hoisted_175 = { class: "t" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_12,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_177 = {
  key: 1,
  class: "noData noData2"
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_13,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_179 = { class: "t" }
const _hoisted_180 = {
  key: 0,
  class: "pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headeradmin = _resolveComponent("headeradmin")!
  const _component_headerComp = _resolveComponent("headerComp")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_footerComp = _resolveComponent("footerComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userInfo?.email)
      ? (_openBlock(), _createBlock(_component_headeradmin, {
          key: 0,
          ref: "headerCompRef",
          positionFixed: true,
          languageData: _ctx.languageData
        }, null, 8, ["languageData"]))
      : (_openBlock(), _createBlock(_component_headerComp, {
          key: 1,
          ref: "headerCompRef",
          positionFixed: true,
          languageData: _ctx.languageData
        }, null, 8, ["languageData"])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.languageData.banner标题1), 1),
              _hoisted_9
            ]),
            _createElementVNode("h1", {
              class: "h4",
              innerHTML: _ctx.languageData.banner标题2
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "text",
            innerHTML: _ctx.languageData.T01标题
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", {
                class: "t",
                innerHTML: _ctx.languageData.T01标题1
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.languageData.T01标题2), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.languageData.item1标题), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.languageData.item1标题_子1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.languageData.item1标题_子2), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.languageData.item1标题_子3), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.languageData.item1标题_子4), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.languageData.item2标题), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.languageData.item2标题_子1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.languageData.item2标题_子2), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.languageData.item2标题_子3), 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.languageData.item2标题_子4), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.languageData.item3标题), 1)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.languageData.item3标题_子1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.languageData.item3标题_子2), 1)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.languageData.item3标题_子3), 1)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.languageData.item3标题_子4), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.languageData.L历史数据), 1),
            _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.languageData.L未来预测), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.languageData.Market标题), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.MethodologyUrl()))
              }, [
                _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.languageData.learnMore), 1),
                _hoisted_79
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.languageData.OurPeople), 1)
                ]),
                _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.languageData.OurPeople描述), 1)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.languageData.Methodology), 1)
                ]),
                _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.languageData.Methodology描述), 1)
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.languageData.IndustryExpertise), 1)
                ]),
                _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.languageData.IndustryExpertise描述), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.languageData.experts标题), 1),
            _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.languageData.experts描述), 1),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", {
                class: "tt",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onshowLogin(_ctx.languageData.experts按钮)))
              }, _toDisplayString(_ctx.languageData.experts按钮), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _hoisted_103,
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.languageData.T02标题), 1)
              ]),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", {
                  class: "tt",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onshowLogin(_ctx.languageData.T02标题按钮)))
                }, _toDisplayString(_ctx.languageData.T02标题按钮), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.languageData.T02标题2), 1),
            _createElementVNode("div", _hoisted_108, [
              _createVNode(_component_swiper, {
                modules: _ctx.modules,
                onSwiper: _ctx.onSwiper,
                "slides-per-view": 3,
                loop: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getenindexData, (item, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "itemBoxT",
                          onClick: ($event: any) => (_ctx.chanPing(item))
                        }, [
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("img", {
                              class: "imgBg",
                              src: item.imgurl,
                              alt: "",
                              srcset: ""
                            }, null, 8, _hoisted_111),
                            _createElementVNode("div", _hoisted_112, _toDisplayString(item.title), 1),
                            _createElementVNode("div", _hoisted_113, _toDisplayString(item.title_desc), 1),
                            _createElementVNode("div", _hoisted_114, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.labers, (items, indexs) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "it",
                                  key: indexs
                                }, [
                                  _hoisted_115,
                                  _createElementVNode("div", _hoisted_116, _toDisplayString(items), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.languageData.learnMore), 1),
                              _hoisted_119
                            ])
                          ])
                        ], 8, _hoisted_109)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules", "onSwiper"]),
              _createElementVNode("view", {
                class: "prevSlide",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
              }),
              _createElementVNode("view", {
                class: "nextSlide",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.languageData.T02定制标题), 1),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.languageData.T02定制Manufacturers数量), 1),
                    _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.languageData.T02定制Manufacturers), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "msg",
                    innerHTML: _ctx.languageData.T02定制Manufacturers描述
                  }, null, 8, _hoisted_127)
                ]),
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.languageData.T02定制Experts数量), 1),
                    _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.languageData.T02定制Experts), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "msg",
                    innerHTML: _ctx.languageData.T02定制Experts描述
                  }, null, 8, _hoisted_132)
                ]),
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.languageData.T02定制Customers数量), 1),
                    _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.languageData.T02定制Customers), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "msg",
                    innerHTML: _ctx.languageData.T02定制Customers描述
                  }, null, 8, _hoisted_137)
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.languageData.T02定制QualityAssurance), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "msg",
                    innerHTML: _ctx.languageData.T02定制QualityAssurance描述
                  }, null, 8, _hoisted_141)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.languageData.T02定制say标题), 1),
              _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.languageData.T02定制say描述), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("div", _hoisted_148, [
            _createElementVNode("div", _hoisted_149, [
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("div", _hoisted_151, _toDisplayString(_ctx.languageData.T02定制Ready标题), 1),
                _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.languageData.T02定制Ready描述), 1)
              ]),
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("div", {
                  class: "tt",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onshowLogin(_ctx.languageData.T02定制Ready按钮)))
                }, _toDisplayString(_ctx.languageData.T02定制Ready按钮), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_154, [
        _createElementVNode("div", _hoisted_155, [
          _createElementVNode("div", _hoisted_156, _toDisplayString(_ctx.languageData.new新闻标题), 1)
        ]),
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("div", _hoisted_158, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aticleSorts, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["btn", _ctx.navIdx == index?'active':'']),
                onClick: ($event: any) => (_ctx.onNav(index))
              }, _toDisplayString(item.type), 11, _hoisted_159))
            }), 256))
          ]),
          (_ctx.total > 0 || _ctx.aticleData?.topitem?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                (_ctx.aticleData?.topitem)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "left",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.IndustrialDetails(_ctx.aticleData?.topitem)))
                    }, [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("img", {
                          class: "img",
                          src: _ctx.aticleData?.topitem.imgurl,
                          alt: "",
                          srcset: ""
                        }, null, 8, _hoisted_162)
                      ]),
                      _createElementVNode("div", _hoisted_163, _toDisplayString(_ctx.aticleData?.topitem.title), 1),
                      _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.aticleData?.topitem.content_txt), 1),
                      _createElementVNode("div", _hoisted_165, _toDisplayString(_ctx.aticleData?.topitem.create_time), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.aticleData?.topitem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_166))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_167, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aticleData3, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list",
                      key: index,
                      onClick: ($event: any) => (_ctx.IndustrialDetails(item))
                    }, [
                      _createElementVNode("div", _hoisted_169, [
                        _createElementVNode("div", _hoisted_170, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_171, _toDisplayString(item.content_txt), 1)
                      ]),
                      _createElementVNode("div", _hoisted_172, [
                        _createElementVNode("div", _hoisted_173, _toDisplayString(item.create_time), 1),
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("div", _hoisted_175, _toDisplayString(_ctx.languageData.learnMore), 1),
                          _hoisted_176
                        ])
                      ])
                    ], 8, _hoisted_168))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_177, [
                _hoisted_178,
                _createElementVNode("div", _hoisted_179, _toDisplayString(_ctx.languageData.C暂无数据), 1)
              ]))
        ]),
        (_ctx.total > 0  || _ctx.aticleData?.topitem?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
              _createVNode(_component_el_pagination, {
                layout: "prev, pager, next",
                "current-page": _ctx.page,
                "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
                total: _ctx.total,
                "page-size": 3,
                onChange: _ctx.changePage
              }, null, 8, ["current-page", "total", "onChange"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_footerComp)
  ]))
}